import { Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, IconButton, Checkbox, Tooltip, TablePagination, Dialog } from "@material-ui/core";
import React, { useState, Fragment } from "react";
import ConfirmDialog from "./ConfirmDialog";
import { globalDeleteService } from "../../../../utils/globalApiServices";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { permissionCheckFnforCamo } from "../../../../utils";
import { PageLoader } from "../../../../shared_elements";
const UtilizationTable = ({ props, bulkOperation = false, heads, bulkFlag, noRecord, data, sort = "", sort_by = "", pagination = {}, onChangePage, onChangeRowsPerPage, createSortHandler, toggleBulkOps, currentRecordPerPage, bulkDeletefn, getResponseBack, toggleBulkClose, basicDetails, isBasicDetailExpanded }) => {
    const [pageLoader, setPageLoader] = useState(false)
    const [open, setOpen] = useState(false);
    const handleClick = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const bulkDeleteBoth = () => {
        const { asset, assetType } = props?.match?.params;
        setPageLoader(true)
        globalDeleteService(`camo/util/bulk_delete/${assetType}/${asset}/?delete_op_hist=yes`, { delete_ids: bulkOperation.ids.map(optionItem => optionItem.id) }).then((response) => {
            if (response?.data?.statusCode === 200) {
                setPageLoader(false)
                props.enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, });
            } else {
                setPageLoader(false)
                props.enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, });
            }
            getResponseBack()
            toggleBulkClose()
        });
    }

    return (
        <Fragment>
            <div id="AmpTable" style={{ height: `${window.innerHeight - (isBasicDetailExpanded ? 475 : 295)}px`, overflow: 'auto' }}>
                <Table className="table-wrapper" id="util">
                    <TableHead>
                        <TableRow>
                            {heads.map((row, index) => (
                                <>
                                    {row?.id === 'utilization_period' && <>
                                        {bulkOperation ? (
                                            <TableCell>
                                                {!permissionCheckFnforCamo({ primaryKey: "utilization", keyIndex: "D" }) || !permissionCheckFnforCamo({ primaryKey: "utilization", keyIndex: "OD" })|| window?.location?.search.includes('archived-assets') ? null : <Checkbox
                                                    size="small"
                                                    checked={bulkFlag}
                                                    onChange={(e) => toggleBulkOps(e.target.checked)}
                                                    name="bulk_operation"
                                                    color="primary"
                                                />}
                                                {!permissionCheckFnforCamo({ primaryKey: "utilization", keyIndex: "D" }) || !permissionCheckFnforCamo({ primaryKey: "utilization", keyIndex: "OD" })|| bulkOperation?.ids?.length > 0 && <Tooltip title="Delete" arrow placement="top">
                                                    <IconButton className="delete-icon">
                                                        <DeleteOutlinedIcon onClick={handleClick} /><span style={{fontSize:'14px'}}>({bulkOperation?.ids?.length})</span>
                                                    </IconButton>
                                                </Tooltip>}  Action(s)
                                            </TableCell>
                                        ) : null}</>
                                    }
                                    <TableCell
                                        key={index}
                                        align={row.actionCell ? "right" : "left"}
                                        padding={"normal"}
                                        sortDirection={
                                            sort === row.id ? (sort_by ? sort_by : "asc") : false
                                        }
                                    >
                                        {row.sortOption && noRecord === null ? (
                                            <TableSortLabel
                                                active={sort === row.id}
                                                direction={sort_by && sort === row.id ? sort_by : "asc"}
                                                onClick={() => createSortHandler(row.id)}
                                            >
                                                {row.label}
                                            </TableSortLabel>
                                        ) : (
                                            <span>{row.label}</span>
                                        )}
                                    </TableCell>
                                </>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {noRecord ? (
                            <TableRow id="table-no-records">
                                <TableCell
                                    colSpan={bulkOperation ? heads.length + 1 : heads.length}
                                    align="center"
                                >
                                    {noRecord}
                                </TableCell>
                            </TableRow>
                        ) : (
                            data
                        )}
                    </TableBody>
                </Table>
            </div>
            {Object.keys(pagination).length && pagination.total > 0 ? (
                <TablePagination
                    rowsPerPageOptions={bulkFlag ? [] : [100, 150, 200, 250]}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={bulkFlag ? pagination.total : currentRecordPerPage}
                    page={pagination.page - 1}
                    backIconButtonProps={{ "aria-label": "previous page" }}
                    nextIconButtonProps={{ "aria-label": "next page" }}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                />
            ) : null}
            <Dialog open={open} onClose={handleClose} id="htDialog">
                <ConfirmDialog
                    handleClose={() => handleClose()}
                    handleDeleteRow={bulkDeletefn}
                    handleDeleteBoth={bulkDeleteBoth}
                    title={bulkOperation?.type === "bulk" ? "Do you really want to delete all the records?" : "Do you really want to delete selected records?"}
                />
            </Dialog>
            {pageLoader ? <PageLoader /> : null}
        </Fragment>

    );
};
export default UtilizationTable